exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AnimationLayer-module__animationlayer___QY9hL{position:absolute;z-index:0;left:0;top:0}", ""]);

// exports
exports.locals = {
	"animationlayer": "AnimationLayer-module__animationlayer___QY9hL"
};